import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'

import EditorTextField from '../../Common/Input/EditorTextField'
import {
  updatePointProperty,
  POINT_PROPERTIES
} from '../../../modules/reducerPoints'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const PEName = ({ id, name }) => {
  // const tag = useSelector(getCurrentTag)
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updatePointProperty(id, POINT_PROPERTIES.NAME, value))
    },
    [dispatch, id]
  )

  return (
    <EditorTextField label="Nombre" value={name} onChange={updateTagValue} />
  )
}
export default PEName
